import { c as re } from "./_commonjsHelpers-92157f1b.mjs";
import { r as Ee } from "./setup-0f23222d.mjs";
import { useEffect as be } from "react";
var ve = { exports: {} }, ne = { exports: {} }, fe;
function we() {
  return fe || (fe = 1, function(q) {
    var N = function() {
      function I(u, s) {
        return s != null && u instanceof s;
      }
      var R;
      try {
        R = Map;
      } catch {
        R = function() {
        };
      }
      var $;
      try {
        $ = Set;
      } catch {
        $ = function() {
        };
      }
      var x;
      try {
        x = Promise;
      } catch {
        x = function() {
        };
      }
      function M(u, s, g, d, o) {
        typeof s == "object" && (g = s.depth, d = s.prototype, o = s.includeNonEnumerable, s = s.circular);
        var l = [], h = [], w = typeof Buffer < "u";
        typeof s > "u" && (s = !0), typeof g > "u" && (g = 1 / 0);
        function P(r, v) {
          if (r === null)
            return null;
          if (v === 0)
            return r;
          var n, S;
          if (typeof r != "object")
            return r;
          if (I(r, R))
            n = new R();
          else if (I(r, $))
            n = new $();
          else if (I(r, x))
            n = new x(function(H, D) {
              r.then(function(K) {
                H(P(K, v - 1));
              }, function(K) {
                D(P(K, v - 1));
              });
            });
          else if (M.__isArray(r))
            n = [];
          else if (M.__isRegExp(r))
            n = new RegExp(r.source, b(r)), r.lastIndex && (n.lastIndex = r.lastIndex);
          else if (M.__isDate(r))
            n = new Date(r.getTime());
          else {
            if (w && Buffer.isBuffer(r))
              return Buffer.allocUnsafe ? n = Buffer.allocUnsafe(r.length) : n = new Buffer(r.length), r.copy(n), n;
            I(r, Error) ? n = Object.create(r) : typeof d > "u" ? (S = Object.getPrototypeOf(r), n = Object.create(S)) : (n = Object.create(d), S = d);
          }
          if (s) {
            var T = l.indexOf(r);
            if (T != -1)
              return h[T];
            l.push(r), h.push(n);
          }
          I(r, R) && r.forEach(function(H, D) {
            var K = P(D, v - 1), O = P(H, v - 1);
            n.set(K, O);
          }), I(r, $) && r.forEach(function(H) {
            var D = P(H, v - 1);
            n.add(D);
          });
          for (var c in r) {
            var L;
            S && (L = Object.getOwnPropertyDescriptor(S, c)), !(L && L.set == null) && (n[c] = P(r[c], v - 1));
          }
          if (Object.getOwnPropertySymbols)
            for (var _ = Object.getOwnPropertySymbols(r), c = 0; c < _.length; c++) {
              var G = _[c], k = Object.getOwnPropertyDescriptor(r, G);
              k && !k.enumerable && !o || (n[G] = P(r[G], v - 1), k.enumerable || Object.defineProperty(n, G, {
                enumerable: !1
              }));
            }
          if (o)
            for (var j = Object.getOwnPropertyNames(r), c = 0; c < j.length; c++) {
              var J = j[c], k = Object.getOwnPropertyDescriptor(r, J);
              k && k.enumerable || (n[J] = P(r[J], v - 1), Object.defineProperty(n, J, {
                enumerable: !1
              }));
            }
          return n;
        }
        return P(u, g);
      }
      M.clonePrototype = function(s) {
        if (s === null)
          return null;
        var g = function() {
        };
        return g.prototype = s, new g();
      };
      function U(u) {
        return Object.prototype.toString.call(u);
      }
      M.__objToStr = U;
      function z(u) {
        return typeof u == "object" && U(u) === "[object Date]";
      }
      M.__isDate = z;
      function p(u) {
        return typeof u == "object" && U(u) === "[object Array]";
      }
      M.__isArray = p;
      function m(u) {
        return typeof u == "object" && U(u) === "[object RegExp]";
      }
      M.__isRegExp = m;
      function b(u) {
        var s = "";
        return u.global && (s += "g"), u.ignoreCase && (s += "i"), u.multiline && (s += "m"), s;
      }
      return M.__getRegExpFlags = b, M;
    }();
    q.exports && (q.exports = N);
  }(ne)), ne.exports;
}
var Z = {}, ee = { exports: {} };
/*! https://mths.be/punycode v1.4.1 by @mathias */
ee.exports;
var ce;
function Oe() {
  return ce || (ce = 1, function(q, N) {
    (function(I) {
      var R = N && !N.nodeType && N, $ = q && !q.nodeType && q, x = typeof re == "object" && re;
      (x.global === x || x.window === x || x.self === x) && (I = x);
      var M, U = 2147483647, z = 36, p = 1, m = 26, b = 38, u = 700, s = 72, g = 128, d = "-", o = /^xn--/, l = /[^\x20-\x7E]/, h = /[\x2E\u3002\uFF0E\uFF61]/g, w = {
        overflow: "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, P = z - p, r = Math.floor, v = String.fromCharCode, n;
      function S(O) {
        throw new RangeError(w[O]);
      }
      function T(O, a) {
        for (var e = O.length, t = []; e--; )
          t[e] = a(O[e]);
        return t;
      }
      function c(O, a) {
        var e = O.split("@"), t = "";
        e.length > 1 && (t = e[0] + "@", O = e[1]), O = O.replace(h, ".");
        var i = O.split("."), f = T(i, a).join(".");
        return t + f;
      }
      function L(O) {
        for (var a = [], e = 0, t = O.length, i, f; e < t; )
          i = O.charCodeAt(e++), i >= 55296 && i <= 56319 && e < t ? (f = O.charCodeAt(e++), (f & 64512) == 56320 ? a.push(((i & 1023) << 10) + (f & 1023) + 65536) : (a.push(i), e--)) : a.push(i);
        return a;
      }
      function _(O) {
        return T(O, function(a) {
          var e = "";
          return a > 65535 && (a -= 65536, e += v(a >>> 10 & 1023 | 55296), a = 56320 | a & 1023), e += v(a), e;
        }).join("");
      }
      function G(O) {
        return O - 48 < 10 ? O - 22 : O - 65 < 26 ? O - 65 : O - 97 < 26 ? O - 97 : z;
      }
      function k(O, a) {
        return O + 22 + 75 * (O < 26) - ((a != 0) << 5);
      }
      function j(O, a, e) {
        var t = 0;
        for (O = e ? r(O / u) : O >> 1, O += r(O / a); O > P * m >> 1; t += z)
          O = r(O / P);
        return r(t + (P + 1) * O / (O + b));
      }
      function J(O) {
        var a = [], e = O.length, t, i = 0, f = g, y = s, E, C, A, F, B, W, V, Q, Y;
        for (E = O.lastIndexOf(d), E < 0 && (E = 0), C = 0; C < E; ++C)
          O.charCodeAt(C) >= 128 && S("not-basic"), a.push(O.charCodeAt(C));
        for (A = E > 0 ? E + 1 : 0; A < e; ) {
          for (F = i, B = 1, W = z; A >= e && S("invalid-input"), V = G(O.charCodeAt(A++)), (V >= z || V > r((U - i) / B)) && S("overflow"), i += V * B, Q = W <= y ? p : W >= y + m ? m : W - y, !(V < Q); W += z)
            Y = z - Q, B > r(U / Y) && S("overflow"), B *= Y;
          t = a.length + 1, y = j(i - F, t, F == 0), r(i / t) > U - f && S("overflow"), f += r(i / t), i %= t, a.splice(i++, 0, f);
        }
        return _(a);
      }
      function H(O) {
        var a, e, t, i, f, y, E, C, A, F, B, W = [], V, Q, Y, X;
        for (O = L(O), V = O.length, a = g, e = 0, f = s, y = 0; y < V; ++y)
          B = O[y], B < 128 && W.push(v(B));
        for (t = i = W.length, i && W.push(d); t < V; ) {
          for (E = U, y = 0; y < V; ++y)
            B = O[y], B >= a && B < E && (E = B);
          for (Q = t + 1, E - a > r((U - e) / Q) && S("overflow"), e += (E - a) * Q, a = E, y = 0; y < V; ++y)
            if (B = O[y], B < a && ++e > U && S("overflow"), B == a) {
              for (C = e, A = z; F = A <= f ? p : A >= f + m ? m : A - f, !(C < F); A += z)
                X = C - F, Y = z - F, W.push(
                  v(k(F + X % Y, 0))
                ), C = r(X / Y);
              W.push(v(k(C, 0))), f = j(e, Q, t == i), e = 0, ++t;
            }
          ++e, ++a;
        }
        return W.join("");
      }
      function D(O) {
        return c(O, function(a) {
          return o.test(a) ? J(a.slice(4).toLowerCase()) : a;
        });
      }
      function K(O) {
        return c(O, function(a) {
          return l.test(a) ? "xn--" + H(a) : a;
        });
      }
      if (M = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        version: "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        ucs2: {
          decode: L,
          encode: _
        },
        decode: J,
        encode: H,
        toASCII: K,
        toUnicode: D
      }, R && $)
        if (q.exports == R)
          $.exports = M;
        else
          for (n in M)
            M.hasOwnProperty(n) && (R[n] = M[n]);
      else
        I.punycode = M;
    })(re);
  }(ee, ee.exports)), ee.exports;
}
var ie, ue;
function he() {
  if (ue)
    return ie;
  ue = 1;
  var q = String.prototype.replace, N = /%20/g, I = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return ie = {
    default: I.RFC3986,
    formatters: {
      RFC1738: function(R) {
        return q.call(R, N, "+");
      },
      RFC3986: function(R) {
        return String(R);
      }
    },
    RFC1738: I.RFC1738,
    RFC3986: I.RFC3986
  }, ie;
}
var oe, de;
function _e() {
  if (de)
    return oe;
  de = 1;
  var q = he(), N = Object.prototype.hasOwnProperty, I = Array.isArray, R = function() {
    for (var o = [], l = 0; l < 256; ++l)
      o.push("%" + ((l < 16 ? "0" : "") + l.toString(16)).toUpperCase());
    return o;
  }(), $ = function(l) {
    for (; l.length > 1; ) {
      var h = l.pop(), w = h.obj[h.prop];
      if (I(w)) {
        for (var P = [], r = 0; r < w.length; ++r)
          typeof w[r] < "u" && P.push(w[r]);
        h.obj[h.prop] = P;
      }
    }
  }, x = function(l, h) {
    for (var w = h && h.plainObjects ? { __proto__: null } : {}, P = 0; P < l.length; ++P)
      typeof l[P] < "u" && (w[P] = l[P]);
    return w;
  }, M = function o(l, h, w) {
    if (!h)
      return l;
    if (typeof h != "object" && typeof h != "function") {
      if (I(l))
        l.push(h);
      else if (l && typeof l == "object")
        (w && (w.plainObjects || w.allowPrototypes) || !N.call(Object.prototype, h)) && (l[h] = !0);
      else
        return [l, h];
      return l;
    }
    if (!l || typeof l != "object")
      return [l].concat(h);
    var P = l;
    return I(l) && !I(h) && (P = x(l, w)), I(l) && I(h) ? (h.forEach(function(r, v) {
      if (N.call(l, v)) {
        var n = l[v];
        n && typeof n == "object" && r && typeof r == "object" ? l[v] = o(n, r, w) : l.push(r);
      } else
        l[v] = r;
    }), l) : Object.keys(h).reduce(function(r, v) {
      var n = h[v];
      return N.call(r, v) ? r[v] = o(r[v], n, w) : r[v] = n, r;
    }, P);
  }, U = function(l, h) {
    return Object.keys(h).reduce(function(w, P) {
      return w[P] = h[P], w;
    }, l);
  }, z = function(o, l, h) {
    var w = o.replace(/\+/g, " ");
    if (h === "iso-8859-1")
      return w.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(w);
    } catch {
      return w;
    }
  }, p = 1024, m = function(l, h, w, P, r) {
    if (l.length === 0)
      return l;
    var v = l;
    if (typeof l == "symbol" ? v = Symbol.prototype.toString.call(l) : typeof l != "string" && (v = String(l)), w === "iso-8859-1")
      return escape(v).replace(/%u[0-9a-f]{4}/gi, function(G) {
        return "%26%23" + parseInt(G.slice(2), 16) + "%3B";
      });
    for (var n = "", S = 0; S < v.length; S += p) {
      for (var T = v.length >= p ? v.slice(S, S + p) : v, c = [], L = 0; L < T.length; ++L) {
        var _ = T.charCodeAt(L);
        if (_ === 45 || _ === 46 || _ === 95 || _ === 126 || _ >= 48 && _ <= 57 || _ >= 65 && _ <= 90 || _ >= 97 && _ <= 122 || r === q.RFC1738 && (_ === 40 || _ === 41)) {
          c[c.length] = T.charAt(L);
          continue;
        }
        if (_ < 128) {
          c[c.length] = R[_];
          continue;
        }
        if (_ < 2048) {
          c[c.length] = R[192 | _ >> 6] + R[128 | _ & 63];
          continue;
        }
        if (_ < 55296 || _ >= 57344) {
          c[c.length] = R[224 | _ >> 12] + R[128 | _ >> 6 & 63] + R[128 | _ & 63];
          continue;
        }
        L += 1, _ = 65536 + ((_ & 1023) << 10 | T.charCodeAt(L) & 1023), c[c.length] = R[240 | _ >> 18] + R[128 | _ >> 12 & 63] + R[128 | _ >> 6 & 63] + R[128 | _ & 63];
      }
      n += c.join("");
    }
    return n;
  }, b = function(l) {
    for (var h = [{ obj: { o: l }, prop: "o" }], w = [], P = 0; P < h.length; ++P)
      for (var r = h[P], v = r.obj[r.prop], n = Object.keys(v), S = 0; S < n.length; ++S) {
        var T = n[S], c = v[T];
        typeof c == "object" && c !== null && w.indexOf(c) === -1 && (h.push({ obj: v, prop: T }), w.push(c));
      }
    return $(h), l;
  }, u = function(l) {
    return Object.prototype.toString.call(l) === "[object RegExp]";
  }, s = function(l) {
    return !l || typeof l != "object" ? !1 : !!(l.constructor && l.constructor.isBuffer && l.constructor.isBuffer(l));
  }, g = function(l, h) {
    return [].concat(l, h);
  }, d = function(l, h) {
    if (I(l)) {
      for (var w = [], P = 0; P < l.length; P += 1)
        w.push(h(l[P]));
      return w;
    }
    return h(l);
  };
  return oe = {
    arrayToObject: x,
    assign: U,
    combine: g,
    compact: b,
    decode: z,
    encode: m,
    isBuffer: s,
    isRegExp: u,
    maybeMap: d,
    merge: M
  }, oe;
}
var ae, pe;
function De() {
  if (pe)
    return ae;
  pe = 1;
  var q = Ee(), N = _e(), I = he(), R = Object.prototype.hasOwnProperty, $ = {
    brackets: function(o) {
      return o + "[]";
    },
    comma: "comma",
    indices: function(o, l) {
      return o + "[" + l + "]";
    },
    repeat: function(o) {
      return o;
    }
  }, x = Array.isArray, M = Array.prototype.push, U = function(d, o) {
    M.apply(d, x(o) ? o : [o]);
  }, z = Date.prototype.toISOString, p = I.default, m = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: N.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: p,
    formatter: I.formatters[p],
    // deprecated
    indices: !1,
    serializeDate: function(o) {
      return z.call(o);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, b = function(o) {
    return typeof o == "string" || typeof o == "number" || typeof o == "boolean" || typeof o == "symbol" || typeof o == "bigint";
  }, u = {}, s = function d(o, l, h, w, P, r, v, n, S, T, c, L, _, G, k, j, J, H) {
    for (var D = o, K = H, O = 0, a = !1; (K = K.get(u)) !== void 0 && !a; ) {
      var e = K.get(o);
      if (O += 1, typeof e < "u") {
        if (e === O)
          throw new RangeError("Cyclic object value");
        a = !0;
      }
      typeof K.get(u) > "u" && (O = 0);
    }
    if (typeof T == "function" ? D = T(l, D) : D instanceof Date ? D = _(D) : h === "comma" && x(D) && (D = N.maybeMap(D, function(Y) {
      return Y instanceof Date ? _(Y) : Y;
    })), D === null) {
      if (r)
        return S && !j ? S(l, m.encoder, J, "key", G) : l;
      D = "";
    }
    if (b(D) || N.isBuffer(D)) {
      if (S) {
        var t = j ? l : S(l, m.encoder, J, "key", G);
        return [k(t) + "=" + k(S(D, m.encoder, J, "value", G))];
      }
      return [k(l) + "=" + k(String(D))];
    }
    var i = [];
    if (typeof D > "u")
      return i;
    var f;
    if (h === "comma" && x(D))
      j && S && (D = N.maybeMap(D, S)), f = [{ value: D.length > 0 ? D.join(",") || null : void 0 }];
    else if (x(T))
      f = T;
    else {
      var y = Object.keys(D);
      f = c ? y.sort(c) : y;
    }
    var E = n ? String(l).replace(/\./g, "%2E") : String(l), C = w && x(D) && D.length === 1 ? E + "[]" : E;
    if (P && x(D) && D.length === 0)
      return C + "[]";
    for (var A = 0; A < f.length; ++A) {
      var F = f[A], B = typeof F == "object" && F && typeof F.value < "u" ? F.value : D[F];
      if (!(v && B === null)) {
        var W = L && n ? String(F).replace(/\./g, "%2E") : String(F), V = x(D) ? typeof h == "function" ? h(C, W) : C : C + (L ? "." + W : "[" + W + "]");
        H.set(o, O);
        var Q = q();
        Q.set(u, H), U(i, d(
          B,
          V,
          h,
          w,
          P,
          r,
          v,
          n,
          h === "comma" && j && x(D) ? null : S,
          T,
          c,
          L,
          _,
          G,
          k,
          j,
          J,
          Q
        ));
      }
    }
    return i;
  }, g = function(o) {
    if (!o)
      return m;
    if (typeof o.allowEmptyArrays < "u" && typeof o.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof o.encodeDotInKeys < "u" && typeof o.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (o.encoder !== null && typeof o.encoder < "u" && typeof o.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var l = o.charset || m.charset;
    if (typeof o.charset < "u" && o.charset !== "utf-8" && o.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = I.default;
    if (typeof o.format < "u") {
      if (!R.call(I.formatters, o.format))
        throw new TypeError("Unknown format option provided.");
      h = o.format;
    }
    var w = I.formatters[h], P = m.filter;
    (typeof o.filter == "function" || x(o.filter)) && (P = o.filter);
    var r;
    if (o.arrayFormat in $ ? r = o.arrayFormat : "indices" in o ? r = o.indices ? "indices" : "repeat" : r = m.arrayFormat, "commaRoundTrip" in o && typeof o.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var v = typeof o.allowDots > "u" ? o.encodeDotInKeys === !0 ? !0 : m.allowDots : !!o.allowDots;
    return {
      addQueryPrefix: typeof o.addQueryPrefix == "boolean" ? o.addQueryPrefix : m.addQueryPrefix,
      allowDots: v,
      allowEmptyArrays: typeof o.allowEmptyArrays == "boolean" ? !!o.allowEmptyArrays : m.allowEmptyArrays,
      arrayFormat: r,
      charset: l,
      charsetSentinel: typeof o.charsetSentinel == "boolean" ? o.charsetSentinel : m.charsetSentinel,
      commaRoundTrip: !!o.commaRoundTrip,
      delimiter: typeof o.delimiter > "u" ? m.delimiter : o.delimiter,
      encode: typeof o.encode == "boolean" ? o.encode : m.encode,
      encodeDotInKeys: typeof o.encodeDotInKeys == "boolean" ? o.encodeDotInKeys : m.encodeDotInKeys,
      encoder: typeof o.encoder == "function" ? o.encoder : m.encoder,
      encodeValuesOnly: typeof o.encodeValuesOnly == "boolean" ? o.encodeValuesOnly : m.encodeValuesOnly,
      filter: P,
      format: h,
      formatter: w,
      serializeDate: typeof o.serializeDate == "function" ? o.serializeDate : m.serializeDate,
      skipNulls: typeof o.skipNulls == "boolean" ? o.skipNulls : m.skipNulls,
      sort: typeof o.sort == "function" ? o.sort : null,
      strictNullHandling: typeof o.strictNullHandling == "boolean" ? o.strictNullHandling : m.strictNullHandling
    };
  };
  return ae = function(d, o) {
    var l = d, h = g(o), w, P;
    typeof h.filter == "function" ? (P = h.filter, l = P("", l)) : x(h.filter) && (P = h.filter, w = P);
    var r = [];
    if (typeof l != "object" || l === null)
      return "";
    var v = $[h.arrayFormat], n = v === "comma" && h.commaRoundTrip;
    w || (w = Object.keys(l)), h.sort && w.sort(h.sort);
    for (var S = q(), T = 0; T < w.length; ++T) {
      var c = w[T], L = l[c];
      h.skipNulls && L === null || U(r, s(
        L,
        c,
        v,
        n,
        h.allowEmptyArrays,
        h.strictNullHandling,
        h.skipNulls,
        h.encodeDotInKeys,
        h.encode ? h.encoder : null,
        h.filter,
        h.sort,
        h.allowDots,
        h.serializeDate,
        h.format,
        h.formatter,
        h.encodeValuesOnly,
        h.charset,
        S
      ));
    }
    var _ = r.join(h.delimiter), G = h.addQueryPrefix === !0 ? "?" : "";
    return h.charsetSentinel && (h.charset === "iso-8859-1" ? G += "utf8=%26%2310003%3B&" : G += "utf8=%E2%9C%93&"), _.length > 0 ? G + _ : "";
  }, ae;
}
var se, me;
function Ce() {
  if (me)
    return se;
  me = 1;
  var q = _e(), N = Object.prototype.hasOwnProperty, I = Array.isArray, R = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: q.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1
  }, $ = function(u) {
    return u.replace(/&#(\d+);/g, function(s, g) {
      return String.fromCharCode(parseInt(g, 10));
    });
  }, x = function(u, s) {
    return u && typeof u == "string" && s.comma && u.indexOf(",") > -1 ? u.split(",") : u;
  }, M = "utf8=%26%2310003%3B", U = "utf8=%E2%9C%93", z = function(s, g) {
    var d = { __proto__: null }, o = g.ignoreQueryPrefix ? s.replace(/^\?/, "") : s;
    o = o.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var l = g.parameterLimit === 1 / 0 ? void 0 : g.parameterLimit, h = o.split(g.delimiter, l), w = -1, P, r = g.charset;
    if (g.charsetSentinel)
      for (P = 0; P < h.length; ++P)
        h[P].indexOf("utf8=") === 0 && (h[P] === U ? r = "utf-8" : h[P] === M && (r = "iso-8859-1"), w = P, P = h.length);
    for (P = 0; P < h.length; ++P)
      if (P !== w) {
        var v = h[P], n = v.indexOf("]="), S = n === -1 ? v.indexOf("=") : n + 1, T, c;
        S === -1 ? (T = g.decoder(v, R.decoder, r, "key"), c = g.strictNullHandling ? null : "") : (T = g.decoder(v.slice(0, S), R.decoder, r, "key"), c = q.maybeMap(
          x(v.slice(S + 1), g),
          function(_) {
            return g.decoder(_, R.decoder, r, "value");
          }
        )), c && g.interpretNumericEntities && r === "iso-8859-1" && (c = $(String(c))), v.indexOf("[]=") > -1 && (c = I(c) ? [c] : c);
        var L = N.call(d, T);
        L && g.duplicates === "combine" ? d[T] = q.combine(d[T], c) : (!L || g.duplicates === "last") && (d[T] = c);
      }
    return d;
  }, p = function(u, s, g, d) {
    for (var o = d ? s : x(s, g), l = u.length - 1; l >= 0; --l) {
      var h, w = u[l];
      if (w === "[]" && g.parseArrays)
        h = g.allowEmptyArrays && (o === "" || g.strictNullHandling && o === null) ? [] : [].concat(o);
      else {
        h = g.plainObjects ? { __proto__: null } : {};
        var P = w.charAt(0) === "[" && w.charAt(w.length - 1) === "]" ? w.slice(1, -1) : w, r = g.decodeDotInKeys ? P.replace(/%2E/g, ".") : P, v = parseInt(r, 10);
        !g.parseArrays && r === "" ? h = { 0: o } : !isNaN(v) && w !== r && String(v) === r && v >= 0 && g.parseArrays && v <= g.arrayLimit ? (h = [], h[v] = o) : r !== "__proto__" && (h[r] = o);
      }
      o = h;
    }
    return o;
  }, m = function(s, g, d, o) {
    if (s) {
      var l = d.allowDots ? s.replace(/\.([^.[]+)/g, "[$1]") : s, h = /(\[[^[\]]*])/, w = /(\[[^[\]]*])/g, P = d.depth > 0 && h.exec(l), r = P ? l.slice(0, P.index) : l, v = [];
      if (r) {
        if (!d.plainObjects && N.call(Object.prototype, r) && !d.allowPrototypes)
          return;
        v.push(r);
      }
      for (var n = 0; d.depth > 0 && (P = w.exec(l)) !== null && n < d.depth; ) {
        if (n += 1, !d.plainObjects && N.call(Object.prototype, P[1].slice(1, -1)) && !d.allowPrototypes)
          return;
        v.push(P[1]);
      }
      if (P) {
        if (d.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + d.depth + " and strictDepth is true");
        v.push("[" + l.slice(P.index) + "]");
      }
      return p(v, g, d, o);
    }
  }, b = function(s) {
    if (!s)
      return R;
    if (typeof s.allowEmptyArrays < "u" && typeof s.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof s.decodeDotInKeys < "u" && typeof s.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (s.decoder !== null && typeof s.decoder < "u" && typeof s.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof s.charset < "u" && s.charset !== "utf-8" && s.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = typeof s.charset > "u" ? R.charset : s.charset, d = typeof s.duplicates > "u" ? R.duplicates : s.duplicates;
    if (d !== "combine" && d !== "first" && d !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var o = typeof s.allowDots > "u" ? s.decodeDotInKeys === !0 ? !0 : R.allowDots : !!s.allowDots;
    return {
      allowDots: o,
      allowEmptyArrays: typeof s.allowEmptyArrays == "boolean" ? !!s.allowEmptyArrays : R.allowEmptyArrays,
      allowPrototypes: typeof s.allowPrototypes == "boolean" ? s.allowPrototypes : R.allowPrototypes,
      allowSparse: typeof s.allowSparse == "boolean" ? s.allowSparse : R.allowSparse,
      arrayLimit: typeof s.arrayLimit == "number" ? s.arrayLimit : R.arrayLimit,
      charset: g,
      charsetSentinel: typeof s.charsetSentinel == "boolean" ? s.charsetSentinel : R.charsetSentinel,
      comma: typeof s.comma == "boolean" ? s.comma : R.comma,
      decodeDotInKeys: typeof s.decodeDotInKeys == "boolean" ? s.decodeDotInKeys : R.decodeDotInKeys,
      decoder: typeof s.decoder == "function" ? s.decoder : R.decoder,
      delimiter: typeof s.delimiter == "string" || q.isRegExp(s.delimiter) ? s.delimiter : R.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof s.depth == "number" || s.depth === !1 ? +s.depth : R.depth,
      duplicates: d,
      ignoreQueryPrefix: s.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof s.interpretNumericEntities == "boolean" ? s.interpretNumericEntities : R.interpretNumericEntities,
      parameterLimit: typeof s.parameterLimit == "number" ? s.parameterLimit : R.parameterLimit,
      parseArrays: s.parseArrays !== !1,
      plainObjects: typeof s.plainObjects == "boolean" ? s.plainObjects : R.plainObjects,
      strictDepth: typeof s.strictDepth == "boolean" ? !!s.strictDepth : R.strictDepth,
      strictNullHandling: typeof s.strictNullHandling == "boolean" ? s.strictNullHandling : R.strictNullHandling
    };
  };
  return se = function(u, s) {
    var g = b(s);
    if (u === "" || u === null || typeof u > "u")
      return g.plainObjects ? { __proto__: null } : {};
    for (var d = typeof u == "string" ? z(u, g) : u, o = g.plainObjects ? { __proto__: null } : {}, l = Object.keys(d), h = 0; h < l.length; ++h) {
      var w = l[h], P = m(w, d[w], g, typeof u == "string");
      o = q.merge(o, P, g);
    }
    return g.allowSparse === !0 ? o : q.compact(o);
  }, se;
}
var le, ge;
function Ae() {
  if (ge)
    return le;
  ge = 1;
  var q = De(), N = Ce(), I = he();
  return le = {
    formats: I,
    parse: N,
    stringify: q
  }, le;
}
var ye;
function Re() {
  if (ye)
    return Z;
  ye = 1;
  var q = Oe();
  function N() {
    this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
  }
  var I = /^([a-z0-9.+-]+:)/i, R = /:[0-9]*$/, $ = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, x = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    `
`,
    "	"
  ], M = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
  ].concat(x), U = ["'"].concat(M), z = [
    "%",
    "/",
    "?",
    ";",
    "#"
  ].concat(U), p = [
    "/",
    "?",
    "#"
  ], m = 255, b = /^[+a-z0-9A-Z_-]{0,63}$/, u = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, s = {
    javascript: !0,
    "javascript:": !0
  }, g = {
    javascript: !0,
    "javascript:": !0
  }, d = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  }, o = Ae();
  function l(r, v, n) {
    if (r && typeof r == "object" && r instanceof N)
      return r;
    var S = new N();
    return S.parse(r, v, n), S;
  }
  N.prototype.parse = function(r, v, n) {
    if (typeof r != "string")
      throw new TypeError("Parameter 'url' must be a string, not " + typeof r);
    var S = r.indexOf("?"), T = S !== -1 && S < r.indexOf("#") ? "?" : "#", c = r.split(T), L = /\\/g;
    c[0] = c[0].replace(L, "/"), r = c.join(T);
    var _ = r;
    if (_ = _.trim(), !n && r.split("#").length === 1) {
      var G = $.exec(_);
      if (G)
        return this.path = _, this.href = _, this.pathname = G[1], G[2] ? (this.search = G[2], v ? this.query = o.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : v && (this.search = "", this.query = {}), this;
    }
    var k = I.exec(_);
    if (k) {
      k = k[0];
      var j = k.toLowerCase();
      this.protocol = j, _ = _.substr(k.length);
    }
    if (n || k || _.match(/^\/\/[^@/]+@[^@/]+/)) {
      var J = _.substr(0, 2) === "//";
      J && !(k && g[k]) && (_ = _.substr(2), this.slashes = !0);
    }
    if (!g[k] && (J || k && !d[k])) {
      for (var H = -1, D = 0; D < p.length; D++) {
        var K = _.indexOf(p[D]);
        K !== -1 && (H === -1 || K < H) && (H = K);
      }
      var O, a;
      H === -1 ? a = _.lastIndexOf("@") : a = _.lastIndexOf("@", H), a !== -1 && (O = _.slice(0, a), _ = _.slice(a + 1), this.auth = decodeURIComponent(O)), H = -1;
      for (var D = 0; D < z.length; D++) {
        var K = _.indexOf(z[D]);
        K !== -1 && (H === -1 || K < H) && (H = K);
      }
      H === -1 && (H = _.length), this.host = _.slice(0, H), _ = _.slice(H), this.parseHost(), this.hostname = this.hostname || "";
      var e = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!e)
        for (var t = this.hostname.split(/\./), D = 0, i = t.length; D < i; D++) {
          var f = t[D];
          if (f && !f.match(b)) {
            for (var y = "", E = 0, C = f.length; E < C; E++)
              f.charCodeAt(E) > 127 ? y += "x" : y += f[E];
            if (!y.match(b)) {
              var A = t.slice(0, D), F = t.slice(D + 1), B = f.match(u);
              B && (A.push(B[1]), F.unshift(B[2])), F.length && (_ = "/" + F.join(".") + _), this.hostname = A.join(".");
              break;
            }
          }
        }
      this.hostname.length > m ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), e || (this.hostname = q.toASCII(this.hostname));
      var W = this.port ? ":" + this.port : "", V = this.hostname || "";
      this.host = V + W, this.href += this.host, e && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), _[0] !== "/" && (_ = "/" + _));
    }
    if (!s[j])
      for (var D = 0, i = U.length; D < i; D++) {
        var Q = U[D];
        if (_.indexOf(Q) !== -1) {
          var Y = encodeURIComponent(Q);
          Y === Q && (Y = escape(Q)), _ = _.split(Q).join(Y);
        }
      }
    var X = _.indexOf("#");
    X !== -1 && (this.hash = _.substr(X), _ = _.slice(0, X));
    var te = _.indexOf("?");
    if (te !== -1 ? (this.search = _.substr(te), this.query = _.substr(te + 1), v && (this.query = o.parse(this.query)), _ = _.slice(0, te)) : v && (this.search = "", this.query = {}), _ && (this.pathname = _), d[j] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      var W = this.pathname || "", Pe = this.search || "";
      this.path = W + Pe;
    }
    return this.href = this.format(), this;
  };
  function h(r) {
    return typeof r == "string" && (r = l(r)), r instanceof N ? r.format() : N.prototype.format.call(r);
  }
  N.prototype.format = function() {
    var r = this.auth || "";
    r && (r = encodeURIComponent(r), r = r.replace(/%3A/i, ":"), r += "@");
    var v = this.protocol || "", n = this.pathname || "", S = this.hash || "", T = !1, c = "";
    this.host ? T = r + this.host : this.hostname && (T = r + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (T += ":" + this.port)), this.query && typeof this.query == "object" && Object.keys(this.query).length && (c = o.stringify(this.query, {
      arrayFormat: "repeat",
      addQueryPrefix: !1
    }));
    var L = this.search || c && "?" + c || "";
    return v && v.substr(-1) !== ":" && (v += ":"), this.slashes || (!v || d[v]) && T !== !1 ? (T = "//" + (T || ""), n && n.charAt(0) !== "/" && (n = "/" + n)) : T || (T = ""), S && S.charAt(0) !== "#" && (S = "#" + S), L && L.charAt(0) !== "?" && (L = "?" + L), n = n.replace(/[?#]/g, function(_) {
      return encodeURIComponent(_);
    }), L = L.replace("#", "%23"), v + T + n + L + S;
  };
  function w(r, v) {
    return l(r, !1, !0).resolve(v);
  }
  N.prototype.resolve = function(r) {
    return this.resolveObject(l(r, !1, !0)).format();
  };
  function P(r, v) {
    return r ? l(r, !1, !0).resolveObject(v) : v;
  }
  return N.prototype.resolveObject = function(r) {
    if (typeof r == "string") {
      var v = new N();
      v.parse(r, !1, !0), r = v;
    }
    for (var n = new N(), S = Object.keys(this), T = 0; T < S.length; T++) {
      var c = S[T];
      n[c] = this[c];
    }
    if (n.hash = r.hash, r.href === "")
      return n.href = n.format(), n;
    if (r.slashes && !r.protocol) {
      for (var L = Object.keys(r), _ = 0; _ < L.length; _++) {
        var G = L[_];
        G !== "protocol" && (n[G] = r[G]);
      }
      return d[n.protocol] && n.hostname && !n.pathname && (n.pathname = "/", n.path = n.pathname), n.href = n.format(), n;
    }
    if (r.protocol && r.protocol !== n.protocol) {
      if (!d[r.protocol]) {
        for (var k = Object.keys(r), j = 0; j < k.length; j++) {
          var J = k[j];
          n[J] = r[J];
        }
        return n.href = n.format(), n;
      }
      if (n.protocol = r.protocol, !r.host && !g[r.protocol]) {
        for (var i = (r.pathname || "").split("/"); i.length && !(r.host = i.shift()); )
          ;
        r.host || (r.host = ""), r.hostname || (r.hostname = ""), i[0] !== "" && i.unshift(""), i.length < 2 && i.unshift(""), n.pathname = i.join("/");
      } else
        n.pathname = r.pathname;
      if (n.search = r.search, n.query = r.query, n.host = r.host || "", n.auth = r.auth, n.hostname = r.hostname || r.host, n.port = r.port, n.pathname || n.search) {
        var H = n.pathname || "", D = n.search || "";
        n.path = H + D;
      }
      return n.slashes = n.slashes || r.slashes, n.href = n.format(), n;
    }
    var K = n.pathname && n.pathname.charAt(0) === "/", O = r.host || r.pathname && r.pathname.charAt(0) === "/", a = O || K || n.host && r.pathname, e = a, t = n.pathname && n.pathname.split("/") || [], i = r.pathname && r.pathname.split("/") || [], f = n.protocol && !d[n.protocol];
    if (f && (n.hostname = "", n.port = null, n.host && (t[0] === "" ? t[0] = n.host : t.unshift(n.host)), n.host = "", r.protocol && (r.hostname = null, r.port = null, r.host && (i[0] === "" ? i[0] = r.host : i.unshift(r.host)), r.host = null), a = a && (i[0] === "" || t[0] === "")), O)
      n.host = r.host || r.host === "" ? r.host : n.host, n.hostname = r.hostname || r.hostname === "" ? r.hostname : n.hostname, n.search = r.search, n.query = r.query, t = i;
    else if (i.length)
      t || (t = []), t.pop(), t = t.concat(i), n.search = r.search, n.query = r.query;
    else if (r.search != null) {
      if (f) {
        n.host = t.shift(), n.hostname = n.host;
        var y = n.host && n.host.indexOf("@") > 0 ? n.host.split("@") : !1;
        y && (n.auth = y.shift(), n.hostname = y.shift(), n.host = n.hostname);
      }
      return n.search = r.search, n.query = r.query, (n.pathname !== null || n.search !== null) && (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.href = n.format(), n;
    }
    if (!t.length)
      return n.pathname = null, n.search ? n.path = "/" + n.search : n.path = null, n.href = n.format(), n;
    for (var E = t.slice(-1)[0], C = (n.host || r.host || t.length > 1) && (E === "." || E === "..") || E === "", A = 0, F = t.length; F >= 0; F--)
      E = t[F], E === "." ? t.splice(F, 1) : E === ".." ? (t.splice(F, 1), A++) : A && (t.splice(F, 1), A--);
    if (!a && !e)
      for (; A--; A)
        t.unshift("..");
    a && t[0] !== "" && (!t[0] || t[0].charAt(0) !== "/") && t.unshift(""), C && t.join("/").substr(-1) !== "/" && t.push("");
    var B = t[0] === "" || t[0] && t[0].charAt(0) === "/";
    if (f) {
      n.hostname = B ? "" : t.length ? t.shift() : "", n.host = n.hostname;
      var y = n.host && n.host.indexOf("@") > 0 ? n.host.split("@") : !1;
      y && (n.auth = y.shift(), n.hostname = y.shift(), n.host = n.hostname);
    }
    return a = a || n.host && t.length, a && !B && t.unshift(""), t.length > 0 ? n.pathname = t.join("/") : (n.pathname = null, n.path = null), (n.pathname !== null || n.search !== null) && (n.path = (n.pathname ? n.pathname : "") + (n.search ? n.search : "")), n.auth = r.auth || n.auth, n.slashes = n.slashes || r.slashes, n.href = n.format(), n;
  }, N.prototype.parseHost = function() {
    var r = this.host, v = R.exec(r);
    v && (v = v[0], v !== ":" && (this.port = v.substr(1)), r = r.substr(0, r.length - v.length)), r && (this.hostname = r);
  }, Z.parse = l, Z.resolve = w, Z.resolveObject = P, Z.format = h, Z.Url = N, Z;
}
(function(q, N) {
  (function(I, R) {
    q.exports = R();
  })(function() {
    try {
      return typeof self < "u";
    } catch {
      return !1;
    }
  }() ? self : re, function() {
    return (() => {
      var I = { 470: (x) => {
        function M(p) {
          if (typeof p != "string")
            throw new TypeError("Path must be a string. Received " + JSON.stringify(p));
        }
        function U(p, m) {
          for (var b, u = "", s = 0, g = -1, d = 0, o = 0; o <= p.length; ++o) {
            if (o < p.length)
              b = p.charCodeAt(o);
            else {
              if (b === 47)
                break;
              b = 47;
            }
            if (b === 47) {
              if (!(g === o - 1 || d === 1))
                if (g !== o - 1 && d === 2) {
                  if (u.length < 2 || s !== 2 || u.charCodeAt(u.length - 1) !== 46 || u.charCodeAt(u.length - 2) !== 46) {
                    if (u.length > 2) {
                      var l = u.lastIndexOf("/");
                      if (l !== u.length - 1) {
                        l === -1 ? (u = "", s = 0) : s = (u = u.slice(0, l)).length - 1 - u.lastIndexOf("/"), g = o, d = 0;
                        continue;
                      }
                    } else if (u.length === 2 || u.length === 1) {
                      u = "", s = 0, g = o, d = 0;
                      continue;
                    }
                  }
                  m && (u.length > 0 ? u += "/.." : u = "..", s = 2);
                } else
                  u.length > 0 ? u += "/" + p.slice(g + 1, o) : u = p.slice(g + 1, o), s = o - g - 1;
              g = o, d = 0;
            } else
              b === 46 && d !== -1 ? ++d : d = -1;
          }
          return u;
        }
        var z = { resolve: function() {
          for (var p, m = "", b = !1, u = arguments.length - 1; u >= -1 && !b; u--) {
            var s;
            u >= 0 ? s = arguments[u] : (p === void 0 && (p = process.cwd()), s = p), M(s), s.length !== 0 && (m = s + "/" + m, b = s.charCodeAt(0) === 47);
          }
          return m = U(m, !b), b ? m.length > 0 ? "/" + m : "/" : m.length > 0 ? m : ".";
        }, normalize: function(p) {
          if (M(p), p.length === 0)
            return ".";
          var m = p.charCodeAt(0) === 47, b = p.charCodeAt(p.length - 1) === 47;
          return (p = U(p, !m)).length !== 0 || m || (p = "."), p.length > 0 && b && (p += "/"), m ? "/" + p : p;
        }, isAbsolute: function(p) {
          return M(p), p.length > 0 && p.charCodeAt(0) === 47;
        }, join: function() {
          if (arguments.length === 0)
            return ".";
          for (var p, m = 0; m < arguments.length; ++m) {
            var b = arguments[m];
            M(b), b.length > 0 && (p === void 0 ? p = b : p += "/" + b);
          }
          return p === void 0 ? "." : z.normalize(p);
        }, relative: function(p, m) {
          if (M(p), M(m), p === m || (p = z.resolve(p)) === (m = z.resolve(m)))
            return "";
          for (var b = 1; b < p.length && p.charCodeAt(b) === 47; ++b)
            ;
          for (var u = p.length, s = u - b, g = 1; g < m.length && m.charCodeAt(g) === 47; ++g)
            ;
          for (var d = m.length - g, o = s < d ? s : d, l = -1, h = 0; h <= o; ++h) {
            if (h === o) {
              if (d > o) {
                if (m.charCodeAt(g + h) === 47)
                  return m.slice(g + h + 1);
                if (h === 0)
                  return m.slice(g + h);
              } else
                s > o && (p.charCodeAt(b + h) === 47 ? l = h : h === 0 && (l = 0));
              break;
            }
            var w = p.charCodeAt(b + h);
            if (w !== m.charCodeAt(g + h))
              break;
            w === 47 && (l = h);
          }
          var P = "";
          for (h = b + l + 1; h <= u; ++h)
            h !== u && p.charCodeAt(h) !== 47 || (P.length === 0 ? P += ".." : P += "/..");
          return P.length > 0 ? P + m.slice(g + l) : (g += l, m.charCodeAt(g) === 47 && ++g, m.slice(g));
        }, _makeLong: function(p) {
          return p;
        }, dirname: function(p) {
          if (M(p), p.length === 0)
            return ".";
          for (var m = p.charCodeAt(0), b = m === 47, u = -1, s = !0, g = p.length - 1; g >= 1; --g)
            if ((m = p.charCodeAt(g)) === 47) {
              if (!s) {
                u = g;
                break;
              }
            } else
              s = !1;
          return u === -1 ? b ? "/" : "." : b && u === 1 ? "//" : p.slice(0, u);
        }, basename: function(p, m) {
          if (m !== void 0 && typeof m != "string")
            throw new TypeError('"ext" argument must be a string');
          M(p);
          var b, u = 0, s = -1, g = !0;
          if (m !== void 0 && m.length > 0 && m.length <= p.length) {
            if (m.length === p.length && m === p)
              return "";
            var d = m.length - 1, o = -1;
            for (b = p.length - 1; b >= 0; --b) {
              var l = p.charCodeAt(b);
              if (l === 47) {
                if (!g) {
                  u = b + 1;
                  break;
                }
              } else
                o === -1 && (g = !1, o = b + 1), d >= 0 && (l === m.charCodeAt(d) ? --d == -1 && (s = b) : (d = -1, s = o));
            }
            return u === s ? s = o : s === -1 && (s = p.length), p.slice(u, s);
          }
          for (b = p.length - 1; b >= 0; --b)
            if (p.charCodeAt(b) === 47) {
              if (!g) {
                u = b + 1;
                break;
              }
            } else
              s === -1 && (g = !1, s = b + 1);
          return s === -1 ? "" : p.slice(u, s);
        }, extname: function(p) {
          M(p);
          for (var m = -1, b = 0, u = -1, s = !0, g = 0, d = p.length - 1; d >= 0; --d) {
            var o = p.charCodeAt(d);
            if (o !== 47)
              u === -1 && (s = !1, u = d + 1), o === 46 ? m === -1 ? m = d : g !== 1 && (g = 1) : m !== -1 && (g = -1);
            else if (!s) {
              b = d + 1;
              break;
            }
          }
          return m === -1 || u === -1 || g === 0 || g === 1 && m === u - 1 && m === b + 1 ? "" : p.slice(m, u);
        }, format: function(p) {
          if (p === null || typeof p != "object")
            throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof p);
          return function(m, b) {
            var u = b.dir || b.root, s = b.base || (b.name || "") + (b.ext || "");
            return u ? u === b.root ? u + s : u + "/" + s : s;
          }(0, p);
        }, parse: function(p) {
          M(p);
          var m = { root: "", dir: "", base: "", ext: "", name: "" };
          if (p.length === 0)
            return m;
          var b, u = p.charCodeAt(0), s = u === 47;
          s ? (m.root = "/", b = 1) : b = 0;
          for (var g = -1, d = 0, o = -1, l = !0, h = p.length - 1, w = 0; h >= b; --h)
            if ((u = p.charCodeAt(h)) !== 47)
              o === -1 && (l = !1, o = h + 1), u === 46 ? g === -1 ? g = h : w !== 1 && (w = 1) : g !== -1 && (w = -1);
            else if (!l) {
              d = h + 1;
              break;
            }
          return g === -1 || o === -1 || w === 0 || w === 1 && g === o - 1 && g === d + 1 ? o !== -1 && (m.base = m.name = d === 0 && s ? p.slice(1, o) : p.slice(d, o)) : (d === 0 && s ? (m.name = p.slice(1, g), m.base = p.slice(1, o)) : (m.name = p.slice(d, g), m.base = p.slice(d, o)), m.ext = p.slice(g, o)), d > 0 ? m.dir = p.slice(0, d - 1) : s && (m.dir = "/"), m;
        }, sep: "/", delimiter: ":", win32: null, posix: null };
        z.posix = z, x.exports = z;
      }, 873: (x, M, U) => {
        U.r(M), U.d(M, { AEM_MODE: () => s, AuthoringUtils: () => j, Constants: () => d, ModelClient: () => G, ModelManager: () => J, ModelStore: () => k, PathUtils: () => c });
        class z {
          constructor() {
          }
        }
        z.PAGE_MODEL_INIT = "cq-pagemodel-init", z.PAGE_MODEL_LOADED = "cq-pagemodel-loaded", z.PAGE_MODEL_UPDATE = "cq-pagemodel-update", z.PAGE_MODEL_ROUTE_CHANGED = "cq-pagemodel-route-changed";
        const p = z;
        class m {
          constructor() {
          }
        }
        m.PAGE_MODEL_ROOT_URL = "cq:pagemodel_root_url", m.PAGE_MODEL_ROUTE_FILTERS = "cq:pagemodel_route_filters", m.PAGE_MODEL_ROUTER = "cq:pagemodel_router", m.WCM_MODE = "cq:wcmmode", m.WCM_DATA_TYPE = "cq:datatype";
        const b = m;
        class u {
          constructor() {
          }
        }
        var s, g;
        u.TYPE_PROP = ":type", u.ITEMS_PROP = ":items", u.ITEMS_ORDER_PROP = ":itemsOrder", u.PATH_PROP = ":path", u.CHILDREN_PROP = ":children", u.HIERARCHY_TYPE_PROP = ":hierarchyType", u.JCR_CONTENT = "jcr:content", function(a) {
          a.EDIT = "edit", a.PREVIEW = "preview", a.DISABLED = "disabled";
        }(s || (s = {})), function(a) {
          a.JS = "script", a.STYLESHEET = "stylesheet";
        }(g || (g = {}));
        const d = u, o = we();
        var l = U.n(o), h = U(470);
        const w = Re();
        var P = U.n(w);
        class r {
          constructor() {
          }
        }
        r.DEFAULT_SLING_MODEL_SELECTOR = "model", r.DEFAULT_MODEL_JSON_EXTENSION = `.${r.DEFAULT_SLING_MODEL_SELECTOR}.json`;
        const v = r, n = /(?:\/)(?:content|apps|libs|etc|etc.clientlibs|conf|mnt\/overlay)(?:\/)/, S = `(.+)/${d.JCR_CONTENT}/(.+)`, T = "http://dummy";
        class c {
          static isBrowser() {
            return typeof window < "u";
          }
          static getContextPath(e) {
            const t = e || this.getCurrentPathname();
            if (!t)
              return "";
            const i = t.match(n), f = i === null ? -1 : i.index || -1;
            return f > 0 ? t.slice(0, f) : "";
          }
          static adaptPagePath(e, t) {
            if (!e)
              return "";
            const i = c.internalize(e);
            return t && i === c.sanitize(t) ? "" : i;
          }
          static externalize(e) {
            const t = this.getContextPath();
            return e.startsWith(t) ? e : `${t}${e}`;
          }
          static internalize(e) {
            if (!e || typeof e != "string")
              return "";
            const t = this.getContextPath();
            return e.replace(new RegExp(`^${t}/`), "/");
          }
          static getMetaPropertyValue(e) {
            let t = null;
            if (this.isBrowser()) {
              const i = document.head.querySelector(`meta[property="${e}"]`);
              t = i ? i.getAttribute("content") : null;
            }
            return t;
          }
          static convertToModelUrl(e) {
            return e && e.replace && e.replace(/\.htm(l)?$/, v.DEFAULT_MODEL_JSON_EXTENSION);
          }
          static getCurrentPageModelUrl() {
            const e = this.getCurrentPathname();
            let t = null;
            return e && (t = this.convertToModelUrl(e) || null), t;
          }
          static getModelUrl(e) {
            return e && e.replace ? this.convertToModelUrl(e) : this.getMetaPropertyValue(b.PAGE_MODEL_ROOT_URL) || this.getCurrentPageModelUrl();
          }
          static sanitize(e) {
            if (!e || typeof e != "string")
              return null;
            let t = P().parse(e, !1, !0).pathname;
            if (t) {
              t = this.internalize(t);
              const i = t.indexOf(".");
              i > -1 && (t = t.substr(0, i)), t = (0, h.normalize)(t);
            }
            return t;
          }
          static addExtension(e, t) {
            if (!t || t.length < 1 || (t.startsWith(".") || (t = "." + t), !e || e.length < 1 || e.indexOf(t) > -1))
              return e;
            let i = this.normalize(e);
            const f = new URL(i, T);
            let y = this.sanitize(f.pathname);
            y = f.origin === T ? y : f.origin + y;
            let E = this._extractPathWithoutResource(f.pathname);
            return E = this._replaceExtension(E, t), i = (y + "." + E + f.search).replace(/\.\./g, "."), i;
          }
          static _extractPathWithoutResource(e) {
            const t = e.split(".");
            return t.shift(), t.join(".");
          }
          static _replaceExtension(e, t) {
            if (e.length < 1)
              return t;
            const i = e.split("/"), f = i[0].split(".");
            let y = f.pop();
            y = y ? y.replace(/htm(l)?/, "") : "";
            let E = f.join(".") + "." + y + t;
            return i.shift(), i.length > 0 && (E += i.join("/")), E;
          }
          static addSelector(e, t) {
            if (!t || t.length < 1 || (t.startsWith(".") || (t = "." + t), !e || e.length < 1 || e.indexOf(t) > -1))
              return e;
            const i = e.indexOf(".") || e.length;
            return i < 0 ? e + t : e.slice(0, i) + t + e.slice(i, e.length);
          }
          static getCurrentPathname() {
            return this.isBrowser() ? window.location.pathname : null;
          }
          static getCurrentURL() {
            return this.isBrowser() ? window.location.href : "";
          }
          static dispatchGlobalCustomEvent(e, t) {
            this.isBrowser() && window.dispatchEvent(new CustomEvent(e, t));
          }
          static join(e) {
            return e ? this.normalize(e.filter((t) => t).join("/")) : "";
          }
          static normalize(e) {
            return e ? e.replace(/\/+/g, "/") : "";
          }
          static makeAbsolute(e) {
            return e && typeof e == "string" ? e.startsWith("/") ? e : "/" + e : "";
          }
          static makeRelative(e) {
            return e && typeof e == "string" ? e.startsWith("/") ? e.slice(1) : e : "";
          }
          static getParentNodePath(e) {
            if (e && e.length > 0) {
              const t = e.lastIndexOf("/") + 1;
              if (t < e.length)
                return e.substring(0, t - 1);
            }
            return null;
          }
          static isItem(e) {
            return new RegExp(S).test(e);
          }
          static getNodeName(e) {
            return (typeof e == "string" ? e.replace(/\/+/g, "/").split(/\//).filter(Boolean) : []).pop() || null;
          }
          static subpath(e, t) {
            if (!e)
              return "";
            const i = c.makeRelative(e).split("/"), f = c.makeRelative(t).split("/");
            if (i.length < f.length)
              return e;
            let y;
            for (y = 0; y < f.length && i[y] === f[y]; ++y)
              ;
            return y === f.length ? i.slice(y).join("/") : e;
          }
          static splitByDelimitators(e, t) {
            let i = [e];
            return t.forEach((f) => {
              let y = [];
              const E = c.normalize(c.makeAbsolute(f) + "/");
              i.forEach((C) => {
                if (y = y.concat(C.split(E)), C.endsWith(f)) {
                  const A = y.splice(y.length - 1, 1)[0];
                  A !== f && (y = y.concat(A.split(c.makeAbsolute(f))));
                }
                y = y.filter((A) => A);
              }), i = y;
            }), i;
          }
          static _getJCRPath(e, t) {
            return [e, d.JCR_CONTENT, t].join("/");
          }
          static splitPageContentPaths(e) {
            if (!e && typeof e != "string")
              return;
            const t = e.split(`/${d.JCR_CONTENT}/`), i = { pagePath: t[0] };
            return t.length > 1 && (i.itemPath = t[1]), i;
          }
          static trimStrings(e, t) {
            return t.forEach((i) => {
              for (; e.startsWith(i); )
                e = c.makeRelative(e.slice(i.length));
              for (; e.endsWith(i); )
                (e = e.slice(0, e.length - i.length)).endsWith("/") && (e = e.slice(0, e.length - 1));
            }), e;
          }
          static _getStartStrings(e, t) {
            let i = "";
            return t.forEach((f) => {
              for (; e.startsWith(f); )
                e = c.makeRelative(e.slice(f.length)), i = `${i}/${f}`;
            }), c.makeRelative(i);
          }
          static toAEMPath(e, t, i) {
            if (this.isBrowser() && window.location.origin === t) {
              const f = `(/editor.html)?(/content/${i = i.replace(/^\/|\/$/g, "")})?`;
              if (e.indexOf(f) < 0)
                return `${f}${e}(.html)?`;
            }
            return e;
          }
        }
        function L(a) {
          c.dispatchGlobalCustomEvent(p.PAGE_MODEL_LOADED, { detail: { model: l()(a) } });
        }
        class _ {
          constructor(e) {
            this._modelManager = e, this._windowListener = (t) => {
              t && t.detail && t.detail.msg ? this._updateModel(t.detail.msg) : console.error("EditorService.js", "No message passed to cq-pagemodel-update", t);
            }, c.isBrowser() && window.addEventListener(p.PAGE_MODEL_UPDATE, this._windowListener);
          }
          _updateModel(e) {
            if (!e || !e.cmd || !e.path)
              return void console.error("PageModelManager.js", "Not enough data received to update the page model");
            const t = e.path, i = e.cmd, f = l()(e.data);
            let y, E, C;
            const A = c.getParentNodePath(t);
            switch (i) {
              case "replace":
                this._modelManager.modelStore.setData(t, f), this._modelManager._notifyListeners(t);
                break;
              case "delete":
                this._modelManager.modelStore.removeData(t), A && this._modelManager._notifyListeners(A);
                break;
              case "insertBefore":
                C = !0;
              case "insertAfter":
                y = c.getNodeName(t), A && (E = A + "/" + f.key, this._modelManager.modelStore.insertData(E, f.value, y, C), this._modelManager._notifyListeners(A));
                break;
              default:
                console.log("EditorClient", "unsupported command:", i);
            }
            L(this._modelManager.modelStore.dataMap);
          }
          destroy() {
            c.isBrowser() && window.removeEventListener(p.PAGE_MODEL_UPDATE, this._windowListener);
          }
        }
        class G {
          constructor(e) {
            this._apiHost = e || null;
          }
          get apiHost() {
            return this._apiHost;
          }
          fetch(e) {
            if (!e) {
              const i = "Fetching model rejected for path: " + e;
              return Promise.reject(new Error(i));
            }
            const t = this._apiHost || "";
            return fetch(`${t}${e}`, { credentials: "same-origin" }).then((i) => {
              if (i.status >= 200 && i.status < 300)
                return i.json();
              throw { response: i };
            }).catch((i) => Promise.reject(i));
          }
          destroy() {
            this._apiHost = null;
          }
        }
        class k {
          constructor(e, t) {
            this._data = null, this._rootPath = null, this._data = {}, e && this.initialize(e, t || {}), this._pageContentDelimiter = [d.JCR_CONTENT];
          }
          initialize(e, t) {
            t && (this._data = t), this._rootPath = e;
          }
          get rootPath() {
            return this._rootPath || "";
          }
          get dataMap() {
            return this._data;
          }
          setData(e, t = {}) {
            const i = c.getNodeName(e);
            if (i) {
              const f = this.getData(c.getParentNodePath(e), !1);
              if (f && f[d.ITEMS_PROP]) {
                const y = l()(t), E = f[d.ITEMS_PROP] || {};
                E[i] && Object.keys(E[i]).forEach((C) => y.value[C] = y.value[C] || ""), E[i] = y.value, f[d.ITEMS_PROP] = E;
              }
            }
          }
          getData(e, t = !0) {
            if (!e && typeof e != "string")
              return t ? l()(this._data) : this._data;
            if (e === this._rootPath || e === `${this._rootPath}/${d.JCR_CONTENT}`)
              return t ? l()(this._data) : this._data;
            const i = c.splitPageContentPaths(e);
            if (i) {
              const f = this._getPageData(i.pagePath);
              if (!f || !i.itemPath)
                return t ? l()(f) : f;
              const y = this._findItemData(i.itemPath, f);
              if (y)
                return t ? l()(y.data) : y.data;
            }
          }
          insertData(e, t, i, f = !1) {
            if (t = l()(t), !e)
              return void console.warn("No path provided for data: " + t);
            if (!c.isItem(e) && this._data)
              return this._data[d.CHILDREN_PROP] || (this._data[d.CHILDREN_PROP] = {}), void (this._data[d.CHILDREN_PROP][e] = t);
            const y = c.splitPageContentPaths(e);
            if (y && y.itemPath) {
              const E = this._getPageData(y.pagePath), C = this._findItemData(y.itemPath, E).parent || E || this._data, A = c.getNodeName(y.itemPath);
              if (A != null && C && Object.prototype.hasOwnProperty.call(C, d.ITEMS_PROP)) {
                const F = C[d.ITEMS_PROP];
                if (F) {
                  F[A] = t;
                  const B = C[d.ITEMS_ORDER_PROP];
                  if (B != null && B.length > 0 && i != null) {
                    const W = B.indexOf(i);
                    W > -1 ? B.splice(f ? W : W + 1, 0, A) : B.push(A);
                  }
                }
              }
            }
          }
          removeData(e) {
            if (!e)
              return null;
            if (!c.isItem(e) && this._data && this._data[d.CHILDREN_PROP])
              return delete this._data[d.CHILDREN_PROP][e], null;
            const t = c.splitPageContentPaths(e);
            if (t && t.itemPath) {
              const i = this._getPageData(t.pagePath), f = this._findItemData(t.itemPath, i);
              if (f.data && f && f.parent && Object.prototype.hasOwnProperty.call(f.parent, d.ITEMS_PROP)) {
                const { parent: y } = f, E = y[d.ITEMS_PROP], C = c.getNodeName(t.itemPath);
                if (C) {
                  E && delete E[C], delete f.data, delete f.parent;
                  const A = y[d.ITEMS_ORDER_PROP];
                  if (A && A.length > 0) {
                    const F = A.indexOf(C);
                    A.splice(F, 1);
                  }
                  return f.parentPath ? f.parentPath : null;
                }
              }
            }
            return console.warn(`Item for path ${e} was not found! Nothing to remove then.`), null;
          }
          destroy() {
            this._data = null, this._rootPath = null, this._pageContentDelimiter = null;
          }
          _findItemData(e, t = this._data, i = null, f = "") {
            const y = { parent: i, parentPath: f };
            if (!t)
              throw new Error("Assertion error: No data provided. This should never happen.");
            const E = t[d.ITEMS_PROP];
            if (!E)
              return y;
            for (const C in E) {
              if (!Object.prototype.hasOwnProperty.call(E, C))
                continue;
              const A = E[C];
              if (C === e)
                return y.data = E[C], y.key = C, y;
              {
                let F = c.subpath(e, C);
                if (!this._pageContentDelimiter)
                  throw new Error("_pageContentDelimiter not set. this should never happen as its set in constructor.");
                {
                  const B = c._getStartStrings(F, this._pageContentDelimiter), W = c.join([f, C, B]);
                  if (F = c.trimStrings(F, this._pageContentDelimiter), F !== e) {
                    const V = this._findItemData(F, A, A, W);
                    if (V)
                      return V;
                  }
                }
              }
            }
            return y;
          }
          _getPageData(e) {
            if (!this._data)
              return;
            if (e === "" || e === this._data[d.PATH_PROP] || e === this.rootPath)
              return this._data;
            const t = this._data[d.CHILDREN_PROP];
            return t && t[e];
          }
        }
        class j {
          constructor(e) {
            this._apiDomain = e;
          }
          getApiDomain() {
            return this._apiDomain;
          }
          getAemLibraries() {
            const e = document.createDocumentFragment();
            if (!j.isRemoteApp() || !j.isEditMode())
              return e;
            const t = this.prependDomain(j.AUTHORING_LIBRARIES.JS), i = this.prependDomain(j.AUTHORING_LIBRARIES.CSS), f = j.AUTHORING_LIBRARIES.META;
            return e.append(this.generateScriptElements(t)), e.append(this.generateLinkElements(i)), e.append(this.generateMetaElements(f)), e;
          }
          setOnLoadCallback(e, t) {
            const i = e.querySelectorAll("script");
            i.length ? i[i.length - 1].onload = () => {
              t();
            } : t();
          }
          generateMetaElements(e) {
            const t = document.createDocumentFragment();
            return Object.entries(e).forEach((i) => {
              const [f, y] = i, E = document.createElement("meta");
              E.setAttribute("property", f), E.content = y, t.appendChild(E);
            }), t;
          }
          generateLinkElements(e) {
            const t = document.createDocumentFragment();
            return e.forEach((i) => {
              const f = document.createElement("link");
              f.type = "text/css", f.rel = "stylesheet", f.href = i, t.appendChild(f);
            }), t;
          }
          generateScriptElements(e) {
            const t = document.createDocumentFragment();
            return e.forEach((i) => {
              const f = document.createElement("script");
              f.type = "text/javascript", f.src = i, f.async = !1, t.appendChild(f);
            }), t;
          }
          static isMode(e) {
            const t = c.getMetaPropertyValue(b.WCM_MODE) === e, i = c.isBrowser() && j.getWCMModeFromURL() === e;
            return t || i;
          }
          static isEditMode() {
            return j.isMode(s.EDIT);
          }
          static isPreviewMode() {
            return j.isMode(s.PREVIEW);
          }
          static isRemoteApp() {
            try {
              return !!new URL(c.getCurrentURL()).searchParams.get(b.WCM_MODE);
            } catch {
            }
            return !1;
          }
          static getWCMModeFromURL() {
            let e;
            try {
              return e = new URL(c.getCurrentURL()), e.searchParams.get(b.WCM_MODE) || "";
            } catch {
            }
            return "";
          }
          prependDomain(e) {
            const t = [], i = this.getApiDomain();
            return e.forEach((f) => {
              t.push(`${i || ""}${f}`);
            }), t;
          }
          static isInEditor() {
            return j.isEditMode() || j.isPreviewMode() || j.isRemoteApp();
          }
        }
        j.EDITOR_CLIENTLIB_PATH = "/etc.clientlibs/cq/gui/components/authoring/editors/clientlibs/", j.AUTHORING_LIBRARIES = { JS: [j.EDITOR_CLIENTLIB_PATH + "internal/messaging.js", j.EDITOR_CLIENTLIB_PATH + "utils.js", j.EDITOR_CLIENTLIB_PATH + "internal/page.js", j.EDITOR_CLIENTLIB_PATH + "internal/pagemodel/messaging.js"], CSS: [j.EDITOR_CLIENTLIB_PATH + "internal/page.css"], META: { [b.WCM_DATA_TYPE]: "JSON" } };
        const J = new class {
          constructor() {
            this._listenersMap = {}, this._fetchPromises = {}, this._modelPaths = {};
          }
          get modelClient() {
            if (!this._modelClient)
              throw new Error("ModelClient is undefined. Call initialize first!");
            return this._modelClient;
          }
          get modelStore() {
            if (!this._modelStore)
              throw new Error("ModelStore is undefined. Call initialize first!");
            return this._modelStore;
          }
          get clientlibUtil() {
            if (!this._clientlibUtil)
              throw new Error("AuthoringUtils is undefined. Call initialize first!");
            return this._clientlibUtil;
          }
          initialize(a) {
            this.initializeAsync(a);
            const { rootModelURL: e, rootModelPath: t } = this._modelPaths;
            if (!e)
              throw new Error("Provide root model url to initialize ModelManager.");
            if (!t)
              throw new Error("No root modelpath resolved! This should never happen.");
            return this._initPromise;
          }
          initializeAsync(a) {
            this.destroy();
            const e = this._toModelConfig(a), t = e && e.model;
            this._initializeFields(e), this._initPromise = this._attachAEMLibraries();
            const { rootModelPath: i } = this._modelPaths;
            this._modelStore = new k(i, t), i && this._setInitializationPromise(i), function() {
              if (K() && c.isBrowser()) {
                const f = window.history.pushState, y = window.history.replaceState;
                window.addEventListener("popstate", (E) => {
                  var C;
                  const A = E == null ? void 0 : E.target;
                  O(((C = A == null ? void 0 : A.location) === null || C === void 0 ? void 0 : C.pathname) || null);
                }), window.history.pushState = (E, C, A) => (O(A), f.apply(history, [E, C, A])), window.history.replaceState = (E, C, A) => (O(A || null), y.apply(history, [E, C, A]));
              }
            }();
          }
          _attachAEMLibraries() {
            if (!c.isBrowser())
              return Promise.resolve();
            const a = this.clientlibUtil.getAemLibraries();
            if (!a.hasChildNodes())
              return Promise.resolve();
            let e;
            const t = new Promise((i) => {
              e = i;
            });
            return this.clientlibUtil.setOnLoadCallback(a, e), window.document.head.appendChild(a), t;
          }
          _initializeFields(a) {
            this._listenersMap = {}, this._fetchPromises = {}, this._initPromise = null, this._modelClient = a && a.modelClient || new G(), this._errorPageRoot = a && a.errorPageRoot || void 0, this._editorClient = new _(this), this._clientlibUtil = new j(this.modelClient.apiHost), this._modelPaths = this._getPathsForModel(a);
          }
          _getPathsForModel(a) {
            const e = a == null ? void 0 : a.path, t = c.getMetaPropertyValue(b.PAGE_MODEL_ROOT_URL), i = c.internalize(t), f = this._isRemoteApp() ? "" : c.getCurrentPathname(), y = f && c.sanitize(f) || "", E = e || i || y;
            return { currentPathname: f, metaPropertyModelURL: i, rootModelURL: E, rootModelPath: c.sanitize(E) || "" };
          }
          _fetchPageModelFromStore() {
            const a = this.modelStore.getData();
            return L(a), a;
          }
          _setInitializationPromise(a) {
            const { rootModelURL: e } = this._modelPaths;
            this._initPromise = this._initPromise.then(() => this._checkDependencies()).then(() => {
              const t = this.modelStore.getData(a);
              return t && Object.keys(t).length > 0 ? (L(t), t) : e ? this._fetchData(e).then((i) => {
                try {
                  return this.modelStore.initialize(a, i), this._fetchActivePageModel(i) || this._fetchPageModelFromStore();
                } catch (f) {
                  console.error("Error on initialization - " + f);
                }
              }) : void 0;
            });
          }
          _fetchActivePageModel(a) {
            const { currentPathname: e, metaPropertyModelURL: t } = this._modelPaths, i = e && c.sanitize(e) || "";
            if (e && i && !D(e) && (y = t, (f = e) && y && c.sanitize(f) !== c.sanitize(y)) && !function(E, C) {
              const A = c.sanitize(C);
              return !!A && !!(E && C && E[d.CHILDREN_PROP] && E[d.CHILDREN_PROP][A]);
            }(a, e))
              return this._fetchData(e).then((E) => (this.modelStore.insertData(i, E), this._fetchPageModelFromStore())).catch((E) => {
                console.warn("caught", E);
              });
            if (e && D(e))
              return this._fetchPageModelFromStore();
            if (!c.isBrowser())
              throw new Error(`Attempting to retrieve model data from a non-browser.
                Please provide the initial data with the property key model`);
            var f, y;
          }
          get rootPath() {
            return this.modelStore.rootPath;
          }
          getData(a) {
            let e = "", t = !1;
            return typeof a == "string" ? e = a : a && (e = a.path || "", t = !!a.forceReload), (this._initPromise || Promise.resolve()).then(() => this._checkDependencies()).then(() => {
              if (!t) {
                const i = this.modelStore.getData(e);
                if (i)
                  return Promise.resolve(i);
              }
              if (c.isItem(e)) {
                const { pageData: i, pagePath: f } = this._getParentPage(e);
                if (!i)
                  return this._fetchData(f).then((y) => (this._storeData(f, y), this.modelStore.getData(e)));
              }
              return this._fetchData(e).then((i) => this._storeData(e, i));
            });
          }
          _fetchData(a) {
            if (Object.prototype.hasOwnProperty.call(this._fetchPromises, a))
              return this._fetchPromises[a];
            if (this.modelClient)
              return new Promise((e, t) => {
                const i = this.modelClient.fetch(this._toModelPath(a));
                this._fetchPromises[a] = i, i.then((f) => {
                  delete this._fetchPromises[a], this._isRemoteApp() && L(f), e(f);
                }).catch((f) => {
                  if (delete this._fetchPromises[a], this._errorPageRoot !== void 0) {
                    const y = typeof f != "string" && f.response ? f.response.status : "500", E = this._errorPageRoot + y + ".model.json";
                    a.indexOf(d.JCR_CONTENT) === -1 && a !== E ? this._fetchData(E).then((C) => {
                      C[d.PATH_PROP] = c.sanitize(a) || a, e(C);
                    }).catch(t) : t(f);
                  } else
                    t(f);
                });
              });
            throw new Error("ModelClient not initialized!");
          }
          _notifyListeners(a) {
            if (a = c.adaptPagePath.call(this, a), !this._listenersMap)
              throw new Error("ListenersMap is undefined.");
            const e = this._listenersMap[a];
            e && e.length && e.forEach((t) => {
              try {
                t();
              } catch (i) {
                console.error(`Error in listener ${e} at path ${a}: ${i}`);
              }
            });
          }
          addListener(a, e) {
            var t;
            if (!a || typeof a != "string" || typeof e != "function")
              return;
            const i = c.adaptPagePath(a, (t = this.modelStore) === null || t === void 0 ? void 0 : t.rootPath);
            this._listenersMap[i] = this._listenersMap[a] || [], this._listenersMap[i].push(e);
          }
          removeListener(a, e) {
            var t;
            if (!a || typeof a != "string" || typeof e != "function")
              return;
            const i = c.adaptPagePath(a, (t = this.modelStore) === null || t === void 0 ? void 0 : t.rootPath), f = this._listenersMap[i];
            if (f) {
              const y = f.indexOf(e);
              y !== -1 && f.splice(y, 1);
            }
          }
          destroy() {
            this._modelClient && this._modelClient.destroy && this._modelClient.destroy(), this._modelStore && this._modelStore.destroy && this._modelStore.destroy(), this._editorClient && this._editorClient.destroy && this._editorClient.destroy();
          }
          _storeData(a, e) {
            let t = !1;
            return this._modelStore && (t = c.isItem(a)), e && Object.keys(e).length > 0 && (this.modelStore.insertData(a, e), this._notifyListeners(a)), t || this._notifyListeners(""), e;
          }
          _toModelPath(a) {
            let e = c.addSelector(a, "model");
            return e = c.addExtension(e, "json"), e = c.externalize(e), c.makeAbsolute(e);
          }
          _toModelConfig(a) {
            return a && typeof a == "string" ? { path: a } : a || {};
          }
          _checkDependencies() {
            return this.modelClient ? this.modelStore ? Promise.resolve() : Promise.reject("No ModelManager registered.") : Promise.reject("No ModelClient registered.");
          }
          _getParentPage(a) {
            const e = c.splitPageContentPaths(a), t = (e == null ? void 0 : e.pagePath) || "";
            return { pageData: this.modelStore.getData(t), pagePath: t };
          }
          _isRemoteApp() {
            const a = this.modelClient.apiHost || "";
            return c.isBrowser() && a.length > 0 && c.getCurrentURL() !== a;
          }
        }();
        class H {
          constructor() {
          }
        }
        function D(a) {
          const e = function() {
            const t = c.getMetaPropertyValue(b.PAGE_MODEL_ROUTE_FILTERS);
            return t ? t.split(",") : [];
          }();
          for (let t = 0, i = e.length; t < i; t++)
            if (new RegExp(e[t]).test(a))
              return !0;
          return !1;
        }
        function K() {
          if (!c.isBrowser())
            return !1;
          const a = c.getMetaPropertyValue(b.PAGE_MODEL_ROUTER);
          return !a || H.DISABLED !== a;
        }
        function O(a) {
          if (!K())
            return;
          const e = function(t) {
            const i = t || c.isBrowser() && window.location.pathname;
            return i ? c.sanitize(i) : null;
          }(a);
          e && e !== "/" && !D(e) && function(t) {
            J.getData({ path: t }).then((i) => {
              c.dispatchGlobalCustomEvent(p.PAGE_MODEL_ROUTE_CHANGED, { detail: { model: i } });
            });
          }(e);
        }
        H.DISABLED = "disabled", H.CONTENT_PATH = "path";
      } }, R = {};
      function $(x) {
        if (R[x])
          return R[x].exports;
        var M = R[x] = { exports: {} };
        return I[x](M, M.exports, $), M.exports;
      }
      return $.n = (x) => {
        var M = x && x.__esModule ? () => x.default : () => x;
        return $.d(M, { a: M }), M;
      }, $.d = (x, M) => {
        for (var U in M)
          $.o(M, U) && !$.o(x, U) && Object.defineProperty(x, U, { enumerable: !0, get: M[U] });
      }, $.o = (x, M) => Object.prototype.hasOwnProperty.call(x, M), $.r = (x) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(x, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(x, "__esModule", { value: !0 });
      }, $(873);
    })();
  });
})(ve);
var Te = ve.exports;
const Ie = (q, N, I) => (be(() => {
  var $, x;
  if (N && (($ = q == null ? void 0 : q.current) != null && $.parentElement)) {
    const M = (x = q == null ? void 0 : q.current) == null ? void 0 : x.parentElement;
    I && (M.style.width = I);
  }
}, [N, I, q]), [N && I ? "100%" : I]);
export {
  Te as a,
  Ie as u
};
